<template>
  <component :is="inline ? 'span' : 'div'">
    <component :is="() => buildVNodes(parsedNodes)" />
  </component>
</template>

<script lang="ts" setup>
import type { DynamicFieldsConfig } from '#types/components/cms/dynamic-fields'
import { CmsCountdown } from '#components'
import { parse } from 'node-html-parser'

const { content, inline, options } = defineProps<{ content: string, inline?: boolean, options: DynamicFieldsConfig }>()

const componentMap = {
  countdown: CmsCountdown,
}

const parsedNodes = content ? parse(content).childNodes : []

const buildVNodes = (nodes) => nodes.map((node) => {
  // Text node
  if (node.nodeType === 3) {
    return node.text
  }

  // Element node
  if (node.nodeType === 1) {
    const componentName = node.getAttribute('data-component')

    if (componentName && componentMap[componentName])
      return h(componentMap[componentName], options[componentName])

    return h(node.rawTagName, node.attributes, buildVNodes(node.childNodes))
  }

  return null
}).filter(Boolean)
</script>
